module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-left.eab4c39f.svg";